export default __webpack_public_path__ + "static/media/024-wreath.6b31b8ef.svg";